export enum ReportRetrievalStatus {
  INACTIVE = 'inactive',
  LOADING = 'loading',
  RENDERING = 'rendering',
}
